import {combineReducers} from 'redux';
import enumsSlice from './enums/enumsRedux';

export const rootReducer = combineReducers({
    enums: enumsSlice.reducer,
});
